export const LIST_STYLE_TYPES = {
  disc: 'disc',
  icon: 'icon',
  custom: 'custom',
};

export const SPACING = {
  default: 'default',
  'spacing-3-xs': 'spacing-3-xs',
};
